<template lang="pug">
.balloonIcon
  p.balloonIcon_value(:class="{ pudding: animate }")
    | {{ value }}
</template>

<script>
export default {
  name: 'BalloonCounter',
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
  },
  data () {
    return {
      animate: false
    }
  },
  computed: {
    valueNode () {
      return this.$el.querySelector(".balloonIcon_value")
    },
    valueLength () {
    }
  },
  watch: {
    value () {
      this.animate = true
      this.valueNode.addEventListener('webkitAnimationEnd', () => {
        this.animate = false
      })
      this.valueNode.addEventListener("animationend", () => {
        this.animate = false
      })
    }
  },
}
</script>

<style lang="styl" scoped>
backgroupd-color = #7C4DFF
text-color = rgb(255, 255, 255)

.balloonIcon
  position relative
  display inline-block
  padding 0 5px
  width 70px
  height 70px
  line-height 70px
  vertical-align middle
  text-align center
  color text-color
  font-size 1.8em
  font-weight bold
  background backgroupd-color
  border-radius 50%
  box-sizing border-box
  box-shadow 0 0 .5em gray

  &:before
    content ""
    position absolute
    bottom -8px
    right -8px
    margin-top -15px
    border 15px solid transparent
    border-left 15px solid backgroupd-color
    z-index 0
    transform rotate(45deg)

.pudding
  animation pudding 0.8s linear 0s 1

pudding-animation()
  0%
    transform scale(1.0, 1.0) translate(0%, 0%)
  15%
    transform scale(0.9, 0.9) translate(0%, 5%)
  30%
    transform scale(1.3, 0.8) translate(0%, 10%)
  50%
    transform scale(0.8, 1.3) translate(0%, -10%)
  70%
    transform scale(1.1, 0.9) translate(0%, 5%)
  100%
    transform scale(1.0, 1.0) translate(0%, 0%)

@keyframes pudding
  pudding-animation()
</style>
